var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-card"},[_c('ul',{staticClass:"status-card-list"},_vm._l((_vm.options),function(option){return _c('li',{key:option.status,staticClass:"status-card-list__item",on:{"click":function($event){return _vm.selectStatusOption(option)}}},[_c('CardDashboard',{attrs:{"type":'statusCard',"option":option}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }